import Cookies from "universal-cookie";
import axios from "axios";

function getCurrentTeamUuid() {
  const cookies = new Cookies();
  const currentTeam = cookies.get("currentTeam");
  
  if (currentTeam) {
    try {
      const team = JSON.parse(currentTeam);
      return team.uuid;
    } catch (e) {
      console.warn('Failed to parse current team from cookies');
    }
  }
  
  // Fallback to legacy team_uuid cookie
  return cookies.get("team_uuid");
}

function injectTeamContext(url, options = {}) {
  const teamUuid = getCurrentTeamUuid();
  
  if (!teamUuid) {
    return { url, options };
  }
  
  // Check if URL contains {team_uuid} placeholder
  if (url.includes('{team_uuid}')) {
    url = url.replace('{team_uuid}', teamUuid);
  } else if (isTeamScopedEndpoint(url)) {
    // Add as query parameter for team-scoped endpoints
    const separator = url.includes('?') ? '&' : '?';
    url += `${separator}team_uuid=${teamUuid}`;
  }
  
  return { url, options };
}

function isTeamScopedEndpoint(url) {
  const teamScopedPaths = [
    '/tier/',
    '/team/',
    '/statistics/',
    '/get_credits/',
    '/projects/',
    '/all_analysis/',
    '/credit-usage-logs',
    '/purchase-entries',
    '/research-pipeline',
    '/conferences' // Add conferences to team-scoped endpoints
  ];
  
  return teamScopedPaths.some(path => url.includes(path));
}

// Enhanced axios request functions with team context
export function teamAwareRequest(method, url, data = null, options = {}) {
  const { url: enhancedUrl, options: enhancedOptions } = injectTeamContext(url, options);
  
  const config = {
    method,
    url: enhancedUrl,
    ...enhancedOptions
  };
  
  if (data) {
    config.data = data;
  }
  
  return axios(config);
}

export function teamAwareGet(url, options = {}) {
  return teamAwareRequest('GET', url, null, options);
}

export function teamAwarePost(url, data, options = {}) {
  return teamAwareRequest('POST', url, data, options);
}

export function teamAwarePut(url, data, options = {}) {
  return teamAwareRequest('PUT', url, data, options);
}

export function teamAwareDelete(url, options = {}) {
  return teamAwareRequest('DELETE', url, null, options);
}

export { getCurrentTeamUuid, injectTeamContext, isTeamScopedEndpoint };